import React from 'react';
import styled from '@benzinga/themetron';

import type { BenzingaLogoVariant } from '../BenzingaLogo';

interface BenzingaItLogoProps {
  variant: BenzingaLogoVariant | undefined;
}
export const BenzingaItLogo: React.FC<BenzingaItLogoProps> = ({ variant }) => {
  const fillColors: string[] = variant === 'light' ? ['#093451', '#fdfdfd', '201px'] : ['#fdfdfd', '#1d2c42', '501px'];
  return (
    <IconWrapper>
      <svg
        baseProfile="tiny"
        height="100%"
        id="Layer_1"
        overflow="visible"
        version="1.2"
        viewBox="0 0 300 40"
        width={fillColors[2]}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill={fillColors[0]} height="100%" width="100%" />
        <g>
          <g>
            <polygon
              fill={fillColors[1]}
              points="29.5,34.1 47.3,34.1 47.3,29.4 34.9,29.4 34.9,23.6 45.2,23.6 45.2,19 34.9,19 34.9,13.7
    47.4,13.7 47.4,9 29.5,9 		"
            />
            <polygon
              fill={fillColors[1]}
              points="68.5,24.7 56.9,8.9 48.9,8.9 51.4,12.1 51.4,34.1 56.7,34.1 56.7,17.6 68.7,34 73.9,34 73.9,8.9
    68.5,8.9 		"
            />
            <path
              d="M22.4,21.2c2.3-0.5,4.3-2.6,4.3-5.7c0-3.3-2.4-6.4-7.2-6.4H3.9l2.4,3.1v22H20c4.8,0,7.3-3,7.3-6.8
    C27.2,24.2,25.1,21.5,22.4,21.2z M11.7,13.7h6.6h0.2c1.8,0,2.9,1.1,2.9,2.6c0,1.6-1.1,2.6-2.9,2.6h-6.7V13.7z M18.6,29.4h-6.9
    v-5.7h6.9c2,0,3.2,1.3,3.2,2.9C21.8,28.3,20.6,29.4,18.6,29.4z"
              fill={fillColors[1]}
            />
            <path
              d="M147.1,24.8h2.8v2.9c-1,0.9-3,1.9-5.1,1.9c-4.5,0-7.6-3.4-7.6-8c0-4.6,3.2-8,7.6-8c2.6,0,4.6,1.4,5.7,3.2
    l4.2-2.3c-1.8-2.9-5-5.4-10-5.4c-7.1,0-13,4.9-13,12.5s5.8,12.5,13,12.5c4.4,0,7.9-1.8,10.3-4.5v-9.3h-11.5L147.1,24.8z"
              fill={fillColors[1]}
            />
            <polygon
              fill={fillColors[1]}
              points="124.1,24.7 112.5,8.9 104.5,8.9 107,12.1 107,34.1 112.3,34.1 112.3,17.6 124.3,34 129.5,34
    129.5,8.9 124.1,8.9 		"
            />
            <path
              d="M172.3,8.9h-10.3l2.5,3.2l-0.5,1.2l-8,20.8h6l1.6-4.2h5.3h5.5l1.6,4.2h6L172.3,8.9z M164.9,25.1l3.9-10.8
    l3.9,10.8h-4H164.9z"
              fill={fillColors[1]}
            />
            <rect fill={fillColors[1]} height="25.1" width="5.4" x="97.5" y="8.9" />
            <polygon
              fill={fillColors[1]}
              points="95.2,13.3 95.2,9 76.1,9 76.1,13.7 88,13.7 76.1,29.8 76.1,34.1 95.2,34.1 95.2,29.4 83.1,29.4
    "
            />
          </g>
          <rect fill="#E4E5E4" height="21.2" width="1.3" x="198.3" y="11" />
          <g transform="translate(-35, 0)">
            <path d="M248.6,31.5V14h3.5v17.5H248.6z" fill="#EA2429" />{' '}
            <path d="M259.5,31.5V16.9h-5.2v-3h13.9v3H263v14.6H259.5z" fill="#EA2429" />{' '}
            <path
              d="M284.5,31.5h-3.9l-1.5-4h-7l-1.4,4h-3.8l6.8-17.5h3.7L284.5,31.5z M278,24.6l-2.4-6.5l-2.4,6.5H278z"
              fill="#EA2429"
            />{' '}
            <path d="M286.5,31.5V14.1h3.5v14.4h8.8v3H286.5z" fill="#EA2429" />{' '}
            <path d="M301.3,31.5V14h3.5v17.5H301.3z" fill="#EA2429" />{' '}
            <path
              d="M324,31.5h-3.9l-1.5-4h-7l-1.4,4h-3.8l6.8-17.5h3.7L324,31.5z M317.5,24.6l-2.4-6.5l-2.4,6.5H317.5z"
              fill="#EA2429"
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
};

const IconWrapper = styled.span`
  &.benzinga-logo {
    display: inline-block;
  }
`;

export default BenzingaItLogo;
